var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page"},[_c('Success',{attrs:{"success":_vm.success}}),_vm._v(" "),_c('Warn',{attrs:{"warn":_vm.warn}}),_vm._v(" "),_c('ErrorCatcher',{ref:"errorCatcher"}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }